import React from 'react'
import { Col, Card, Button, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import styles from './bundleItemCard.module.css'

type Props = {
  imageSrc: string
  itemTitle: string
  itemButtonUrl: string
  itemActive: boolean
}

const UnbundledItemCard = ({
  imageSrc,
  itemTitle,
  itemButtonUrl,
  itemActive
}: Props) => {
  return (
    <>
      <Col xs={12} lg={4} className="pb-5 ">
        <Card className={styles.itemCard} data-testid="card-unbundled">
          <div>
            <Card.Img
              variant="top"
              src={imageSrc || '/image.png'}
              alt="img-item"
              width="100%"
              height="250px"
              className="img-items"
              data-testid="item-image"
            />
            {itemActive ? (
              <Button variant="info" className={styles.listingActive}>
                ACTIVE
              </Button>
            ) : (
              <Button variant="danger" className={styles.listingDisabled}>
                DISABLED
              </Button>
            )}
          </div>
          <Card.Body className="d-flex flex-column pt-0">
            <Row className="pb-5 ">
              <Col>
                <Card.Title>
                  <h3>
                    <b>
                      {itemTitle.substring(0, 20)}{' '}
                      {itemTitle.length > 20 ? <span>...</span> : null}
                    </b>
                  </h3>
                </Card.Title>
              </Col>
            </Row>

            <Link to={itemButtonUrl!} className="mt-auto pt-5">
              <button
                className="btn btn-primary px-4 py-2 "
                data-testid="item-button"
              >
                Edit
              </button>
            </Link>
          </Card.Body>
        </Card>
      </Col>
    </>
  )
}

export default UnbundledItemCard
